(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("6T1J1", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $503937b663c395c4$export$882461b6382ed46c, (v) => $503937b663c395c4$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $503937b663c395c4$export$757ceba2d55c277e, (v) => $503937b663c395c4$export$757ceba2d55c277e = v);
var $503937b663c395c4$export$882461b6382ed46c;
var $503937b663c395c4$export$757ceba2d55c277e;
'use strict';

var $2pmb0 = parcelRequire("2pmb0");
var $503937b663c395c4$var$i;
$503937b663c395c4$export$882461b6382ed46c = $2pmb0.createRoot;
$503937b663c395c4$export$757ceba2d55c277e = $2pmb0.hydrateRoot;

});

})();
//# sourceMappingURL=client.ca81dd86.js.map
